import { ReactNode } from 'react';
import { Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

function HelpTooltip({ content }: { content: ReactNode }) {
  return (
    <Tooltip
      config={{
        arrow: true,
        component: <div className="mediaQualityAssuranceSystem__tooltipContent">{content}</div>,
        interactions: [TooltipInteractionEnum.hover],
        placement: 'bottom',
        strategy: 'absolute'
      }}
    >
      <i className="mediaQualityAssuranceSystem__tooltipIcon fa-regular fa-circle-info" />
    </Tooltip>
  );
}

export default HelpTooltip;
